import React from "react";
import variables from "../../themes/base/styles/variables";
import { Text } from "react_reusable_components";
import useResponsive from "../../core/hooks/useResponsive";
import DatePickerContainer from "../DatePickerContainer/DatePickerContainer";
import { planAuditFieldName } from "../../validationSchema/planAuditSchema";
import {
  disabledDate,
  getLocalizedMessage,
} from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import Style from "./TentativeDateContainer.module.scss";

const TentativeDateContainerStyle = {
  wrapper: {
    padding: variables.paddingSmall,
    paddingBottom: variables.paddingSmallLG,
    border: `1px solid ${variables.grey4}`,
    backgroundColor: variables.whiteSmoke,
  },
  heading: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  },
  gridBox: (isMd) => ({
    display: "grid",
    gridTemplateColumns: isMd && variables.tentativeDateTableGrid,
    gap: variables.gapSmall,
  }),
  tableHeader: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    fontWeight: variables.fontWeightBold,
    color: variables.textDefault,
  },
  dnsdName: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
    textTransform: "capitalize",
  },
};

export default function TentativeDateContainer({
  values,
  errors,
  setFieldValue,
  dnsdList,
  tmList = [],
  touched,
}) {
  const intl = useIntl();
  const responsive = useResponsive();
  function handleDateChange(date, i) {
    setFieldValue(
      `${[planAuditFieldName.DNSD_OBJ_ARR]}.${i}.${
        planAuditFieldName.TENTATIVE_DATE
      }`,
      date
    );
  }

  return (
    <div style={TentativeDateContainerStyle.wrapper}>
      {responsive.isMd && (
        <div style={TentativeDateContainerStyle.gridBox(responsive.isMd)}>
          <Text style={TentativeDateContainerStyle.tableHeader}>
            {getLocalizedMessage(intl, "planAudit.table.dnsd")}
          </Text>
          <Text style={TentativeDateContainerStyle.tableHeader}>
            {getLocalizedMessage(intl, "planAudit.table.tentativeDate")}
          </Text>
          <Text style={TentativeDateContainerStyle.tableHeader}>
            {getLocalizedMessage(intl, "planAudit.tm.placeholder")}
          </Text>
        </div>
      )}
      {values[planAuditFieldName.DNSD_OBJ_ARR]?.map?.(({ dnsd_id }, i) => (
        <>
          <div
            style={{
              ...TentativeDateContainerStyle.gridBox(responsive.isMd),
              alignItems: variables.alignCenter,
              marginTop: variables.marginLarge3,
            }}
          >
            <Text style={TentativeDateContainerStyle.dnsdName}>
              {dnsdList?.find?.((dnsd) => dnsd?.id === dnsd_id)?.name}
            </Text>
            <DatePickerContainer
              size={"small"}
              required
              onChange={(date) => handleDateChange(date, i)}
              name={
                planAuditFieldName.DNSD_OBJ_ARR +
                `.${i}.` +
                planAuditFieldName.TENTATIVE_DATE
              }
              value={
                values[planAuditFieldName.DNSD_OBJ_ARR][i][
                  planAuditFieldName.TENTATIVE_DATE
                ]
              }
              error={
                touched[planAuditFieldName.DNSD_OBJ_ARR]?.[i]?.[
                  planAuditFieldName.TENTATIVE_DATE
                ] &&
                errors[planAuditFieldName.DNSD_OBJ_ARR]?.[i]?.[
                  planAuditFieldName.TENTATIVE_DATE
                ]
              }
              disabledDate={(current) => disabledDate(current)}
            />
            <CustomSelect
              required={true}
              placeholder={getLocalizedMessage(
                intl,
                "planAudit.tm.placeholder"
              )}
              showSearch={false}
              options={tmList?.map?.(({ name, id, isActive }) => {
                return {
                  label: (
                    <Text
                      className={`${Style["select-item-style"]} ${
                        !isActive && Style["low-opacity"]
                      }`}
                    >
                      {name}
                    </Text>
                  ),
                  value: id,
                  disabled: !isActive,
                };
              })}
              name={
                planAuditFieldName.DNSD_OBJ_ARR +
                `.${i}.` +
                planAuditFieldName.TM_ID
              }
              value={
                values[planAuditFieldName.DNSD_OBJ_ARR][i][
                  planAuditFieldName.TM_ID
                ]
              }
              onChange={(e) =>
                setFieldValue(
                  `${[planAuditFieldName.DNSD_OBJ_ARR]}.${i}.${
                    planAuditFieldName.TM_ID
                  }`,
                  e
                )
              }
              error={
                touched[planAuditFieldName.DNSD_OBJ_ARR]?.[i]?.[
                  planAuditFieldName.TM_ID
                ] &&
                errors[planAuditFieldName.DNSD_OBJ_ARR]?.[i]?.[
                  planAuditFieldName.TM_ID
                ]
              }
            />
          </div>
        </>
      ))}
    </div>
  );
}
